<template>
	<div v-show="sponsors.length" class="white py-7">
		<v-container class="text-center">
			<v-row justify="center">
				<v-col cols="12">
					<h1>الرعاة</h1>
				</v-col>
				<v-col v-for="sponsor in sponsors" :key="sponsor.image" cols="6" sm="4" md="3" lg="2" xl="1">
					<v-tooltip bottom>
						<template #activator="{ on }">
							<a :href="sponsor.link" target="_blank" v-on="on">
								<!-- 120 108  97 84 -->
								<v-img contain height="80" class="sponsor" alt="sponsor" :src="sponsor.image"></v-img>
							</a>
						</template>
						<span class="text-center">
							<h3>{{ sponsor.name }}</h3>
							<h4>{{ sponsor.type }}</h4>
						</span>
					</v-tooltip>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import client from "@/client";

export default {
	data() {
		return {
			sponsors: []
		};
	},

	mounted() {
		this.getInfo();
	},
	methods: {
		getInfo() {
			client
				.get("/api/system/sponsors")
				.then(response => {
					this.sponsors = response.data.data || [];
				})
				.finally(() => {
					this.loading = false;
				});
		},
	}
};
</script>

<style scoped>
.sponsor {
	filter: grayscale(100%);
	opacity: 0.4;
	transition: 500ms;
}

.sponsor:hover {
	filter: grayscale(0);
	opacity: 1;
	transform: scale(1.05);
}
</style>